import { render, staticRenderFns } from "./OrbitControls.vue?vue&type=template&id=cd6d7050&scoped=true&"
import script from "./OrbitControls.vue?vue&type=script&lang=js&"
export * from "./OrbitControls.vue?vue&type=script&lang=js&"
import style0 from "./OrbitControls.scss?vue&type=style&index=0&id=cd6d7050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6d7050",
  null
  
)

export default component.exports